import { classNames } from 'tradera/utils/class-names';
import React from 'react';
import type { PolymorphicComponent } from 'react-polymorphed';
import { useLocalizedPriceFormatter } from 'tradera/localization/use-localized-price-formatter';

type DiscountedPriceLabelProps = {
    className?: string;
    price?: number;
    discountRate?: number;
};

export const DiscountedPriceLabel: PolymorphicComponent<
    'span',
    DiscountedPriceLabelProps
> = ({ className, price, discountRate, as: Component = 'span' }) => {
    const localizedPriceFormatter = useLocalizedPriceFormatter();

    if (!price) {
        return null;
    }

    const formattedPrice = localizedPriceFormatter(price);

    return (
        <Component className={classNames('text-function', className)}>
            <del>{formattedPrice}</del>
            <span className="text-danger pl-1">{discountRate}%</span>
        </Component>
    );
};
